import angular from 'angular';
import insuranceReferralsSection from './insuranceReferralsSection';
import './style.scss';

export default angular
  .module('scenes.loanAppSections.scenes.insuranceReferralsSection', [])
  .component('insuranceReferralsSection', insuranceReferralsSection).name;
